import createReducer from 'utils/createReducer';

const SET_FILTER = 'queued/SET_FILTER';

// Initial State
const INIT_STATE = {
  filters: {},
  loading: false,
  error: null,
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_FILTER](state, payload) {
    return {
      ...state,
      filters: payload,
    };
  },
});

export const setFilter = (filters) => ({
  type: SET_FILTER,
  payload: filters,
});
